import React from 'react';
import moment from 'moment';
import capitalize from 'lodash/capitalize';
import { TextLink } from '@lightspeed/cirrus-text';

import Table, { TABLE_TYPES, TABLE_CELL_ALIGN } from 'cirrus/Table';

import { logPropTypes, STATUS_CODES } from './utils';

const renderObjectIDs = ids =>
  ids.map((id, index) => (
    <span key={id}>
      {!!index && ', '}
      <TextLink>{id}</TextLink>
    </span>
  ));

const AuditTrailDetailsAction = props => {
  const { log } = props;

  const {
    id,
    action,
    component,
    details,
    eventTimestamp,
    eventType,
    object,
    objectIDs = [],
    source,
    sourceTimestamp,
    status,
    visibility,
  } = log;

  const tableHead = {
    hide: true,
    cells: [
      {
        key: 'fist-prop',
        width: '40%',
      },
      {
        key: 'first-details',
        width: '60%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
      {
        key: 'second-prop',
        width: '40%',
      },
      {
        key: 'second-details',
        width: '60%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
      {
        key: 'third-prop',
        width: '40%',
      },
      {
        key: 'third-details',
        width: '60%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
    ],
  };

  const tableBody = [
    {
      key: 'first-row',
      cells: [
        { content: 'ID:', className: 'cr-text--bold' },
        { content: id || 'N/A' },
        { content: 'Source:', className: 'cr-text--bold' },
        { content: source || 'N/A' },
        { content: 'Type:', className: 'cr-text--bold' },
        { content: eventType || 'N/A' },
      ],
    },
    {
      key: 'second-row',
      cells: [
        { content: 'Action:', className: 'cr-text--bold' },
        { content: action || 'N/A' },
        { content: 'Source Time:', className: 'cr-text--bold' },
        { content: moment(sourceTimestamp).format('h:mma D MMM, YYYY') },
        { content: 'Details:', className: 'cr-text--bold' },
        { content: details || 'N/A' },
      ],
    },
    {
      key: 'third-row',
      cells: [
        { content: 'Action Time:', className: 'cr-text--bold' },
        { content: moment(eventTimestamp).format('h:mma D MMM, YYYY') },
        { content: 'Object(s):', className: 'cr-text--bold' },
        { content: object ? capitalize(object) : 'N/A' },
        { content: 'Visibility:', className: 'cr-text--bold' },
        { content: visibility || 'N/A' },
      ],
    },
    {
      key: 'forth-row',
      cells: [
        { content: 'Status:', className: 'cr-text--bold' },
        { content: status === STATUS_CODES.TRUE ? 'Completed' : 'Failed' },
        { content: 'Object ID(s):', className: 'cr-text--bold' },
        { content: objectIDs.length ? renderObjectIDs(objectIDs) : 'N/A' },
        { content: 'Component:', className: 'cr-text--bold' },
        { content: component || 'N/A' },
      ],
    },
  ];

  return (
    <div className="cr-flex cr-width-full cr-flex-row">
      <Table
        type={TABLE_TYPES.COMPACT}
        className="cr-mh-3 cr-flex-1"
        head={tableHead}
        body={tableBody}
      />
    </div>
  );
};

AuditTrailDetailsAction.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetailsAction;
